import React from 'react';
import { useIntl, history } from 'umi';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { datamapIntelligenceSourcesPath } from '@intelligence/utils/common';
import DataSourceBubbleInfo from '../DataSourceBubbleInfo';

interface IStatusBubbleContentProps {
  descId: string;
}

export default function StatusBubbleContent({ descId }: IStatusBubbleContentProps) {
  const { formatMessage } = useIntl();

  return (
    <span>
      {formatMessage({ id: descId })}
      <br />
      <DataSourceBubbleInfo
        dataSource="sensortower"
        isNewMore
        customActions={() => {
          history.push({
            pathname: datamapIntelligenceSourcesPath,
            query: {
              sourceValue: 'Sensor Tower',
            },
          });
        }}
        comesFormDom={
          <>
            <img
              src={getDataSourceIcon('sensortower')}
              style={{ width: 14, height: 14, verticalAlign: 'middle', margin: '0 2px' }}
            />
            Sensor Tower
          </>
        }
      />
    </span>
  );
}
